// src/utils/metaPixel.js

export const initMetaPixel = (pixelId) => {
  if (typeof window === "undefined") return;
  if (window.fbq) return; // already initialized, don't re-inject

  const fbq = function () {
    fbq.callMethod
      ? fbq.callMethod.apply(fbq, arguments)
      : fbq.queue.push(arguments);
  };

  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  const firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode.insertBefore(script, firstScript);

  window.fbq("init", pixelId);
};

export const trackEvent = (eventName, params = {}, eventId) => {
  if (typeof window === "undefined" || !window.fbq) return;

  if (eventId) {
    window.fbq("track", eventName, params, { eventID: eventId });
  } else {
    window.fbq("track", eventName, params);
  }
};

export const trackCustomEvent = (eventName, params = {}, eventId) => {
  if (typeof window === "undefined" || !window.fbq) return;

  if (eventId) {
    window.fbq("trackCustom", eventName, params, { eventID: eventId });
  } else {
    window.fbq("trackCustom", eventName, params);
  }
};